<main
    class="flex min-h-screen w-full items-center justify-center bg-[var(--bgColorPrimary)] px-4 py-8 text-[var(--textColor)] sm:px-8"
>
    <div class="w-full max-w-[42rem]">
        <section
            class="border border-[rgb(var(--ui-6))] border-l-4 border-l-[rgb(var(--ui-2))] bg-[var(--base-4)] p-6 shadow-[0_2px_8px_rgba(0,0,0,0.12)] sm:p-10"
            aria-labelledby="screen-too-small-title"
            aria-describedby="screen-too-small-description"
        >
            <sh-icon icon="warning" size="l" aria-hidden="true" class="mb-5 text-[rgb(var(--ui-2))]" />
            <h1 id="screen-too-small-title" class="mb-4 text-2xl leading-tight">
                {{ titleText() }}
            </h1>
            <div id="screen-too-small-description" class="text-base leading-6" [innerHTML]="descriptionText()"></div>
        </section>
    </div>
</main>
